<template>
  <div class="containar">
    <div class="nyan-clock-contents-block">
      <div id="nyanClock">
        <div class="clock-preview nyan-font">
            <span class="nyan-date">{{ date }}<span class="nyan-youbi">{{ dayOfWeek }}</span></span>
            <span class="nyan-time">{{ hours }}:{{ minutes }}</span>
            <div class="nyan-icon-area">
                <div class="nyan-icon-1"></div>
                <div class="nyan-icon-2"></div>
                <div class="nyan-icon-3"></div>
                <img src="@/assets/image/nya.svg" alt="肉球" width="32" height="32">
                <div class="nyan-icon-3"></div>
                <div class="nyan-icon-2"></div>
                <div class="nyan-icon-1"></div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      hours: "",
      minutes: "",
      date: "",
      dayOfWeek: "",
    };
  },

  computed: {
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime: function () {
      let currentdate = new Date();
      let hours = currentdate.getHours();
      this.hours = this.zeroPadding(hours, 2);
      this.minutes = this.zeroPadding(currentdate.getMinutes(), 2);

      // 日付と曜日の更新
      this.date = `${this.zeroPadding(currentdate.getMonth() + 1, 2)} / ${this.zeroPadding(currentdate.getDate(), 2)}`;
      const days = ['SUN.', 'MON.', 'TUE.', 'WED.', 'THU.', 'FRI.', 'SAT.'];
      this.dayOfWeek = days[currentdate.getDay()];
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.nyan-clock-contents-block{
  text-align: center;
  display: block;
  margin: auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}

#nyanClock {
  width: 282px;
  height: 176px;
  margin: 12px 12px 12px 12px;
  padding-top: 18px;
  display: flex;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: #FFF9F1;
  border-radius: 0 0 14px 14px;
  border-right: 5px solid #8E3605;
  border-bottom: 5px solid #8E3605;
  border-left: 5px solid #8E3605;
  border-top: none;
}

.nyan-date {
  letter-spacing: 0.1em;
  font-size: 18px;
  margin-left:12px;
  margin-bottom: 14px;
  display: block;
  text-align: center;
  color: #8E3605;
  font-weight: bold;
}

.nyan-youbi {
  font-size: 18px;
  margin-left: 10px;
}

.nyan-time {
  letter-spacing: 0.06em;
  font-size: 70.4px;
  line-height: 0.75em;
  margin-bottom: 10px;
  color: #8E3605;
  margin-left:10px;
}

.set{
  padding: 8px 12px 24px 12px;
  margin-top: 24px;
  background-color: #f9f3e9;
}

.nyan-icon-area{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 10px auto;
  padding: 0 12px;
  box-sizing: border-box;
}

.nyan-icon-1{
  width: 8px;
  height: 8px;
  background-color: #FDA43C;
  border-radius: 50%;
}

.nyan-icon-2{
  width: 8px;
  height: 8px;
  background-color: #E8B6FF;
  border-radius: 50%;
}

.nyan-icon-3{
  width: 8px;
  height: 8px;
  background-color: #3ADED4;
  border-radius: 50%;
}

.nyan-font{
  font-family: "Maven Pro", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
}

.radio-main{
  display: -webkit-flex;
  display: flex;
  margin-top:12px;
}

.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

</style>